/* eslint-disable import/max-dependencies -- generated translation catalog imports every locale namespace */
import catalogEnUSBillingHistory from "../../../../translations/locales/en-US/billingHistory.json";
import catalogEnUSChangeOfOwnership from "../../../../translations/locales/en-US/changeOfOwnership.json";
import catalogEnUSCharting from "../../../../translations/locales/en-US/charting.json";
import catalogEnUSChat from "../../../../translations/locales/en-US/chat.json";
import catalogEnUSCommon from "../../../../translations/locales/en-US/common.json";
import catalogEnUSDnr from "../../../../translations/locales/en-US/dnr.json";
import catalogEnUSEvidence from "../../../../translations/locales/en-US/evidence.json";
import catalogEnUSFacilityUser from "../../../../translations/locales/en-US/facilityUser.json";
import catalogEnUSGettingStarted from "../../../../translations/locales/en-US/gettingStarted.json";
import catalogEnUSHelpCenter from "../../../../translations/locales/en-US/helpCenter.json";
import catalogEnUSHomeHealth from "../../../../translations/locales/en-US/homeHealth.json";
import catalogEnUSLiveWorkerEta from "../../../../translations/locales/en-US/liveWorkerEta.json";
import catalogEnUSLogin from "../../../../translations/locales/en-US/login.json";
import catalogEnUSMissedPunchRequest from "../../../../translations/locales/en-US/missedPunchRequest.json";
import catalogEnUSMyAccount from "../../../../translations/locales/en-US/myAccount.json";
import catalogEnUSMyProfessionals from "../../../../translations/locales/en-US/myProfessionals.json";
import catalogEnUSNavigation from "../../../../translations/locales/en-US/navigation.json";
import catalogEnUSOrientation from "../../../../translations/locales/en-US/orientation.json";
import catalogEnUSPrnRoster from "../../../../translations/locales/en-US/prnRoster.json";
import catalogEnUSPushNotifications from "../../../../translations/locales/en-US/pushNotifications.json";
import catalogEnUSRateRequest from "../../../../translations/locales/en-US/rateRequest.json";
import catalogEnUSRatingPrompt from "../../../../translations/locales/en-US/ratingPrompt.json";
import catalogEnUSReferAndEarn from "../../../../translations/locales/en-US/referAndEarn.json";
import catalogEnUSReporting from "../../../../translations/locales/en-US/reporting.json";
import catalogEnUSRequiredDocuments from "../../../../translations/locales/en-US/requiredDocuments.json";
import catalogEnUSRequirementV2 from "../../../../translations/locales/en-US/requirementV2.json";
import catalogEnUSSchedule from "../../../../translations/locales/en-US/schedule.json";
import catalogEnUSSettings from "../../../../translations/locales/en-US/settings.json";
import catalogEnUSShift from "../../../../translations/locales/en-US/shift.json";
import catalogEnUSShiftMigration from "../../../../translations/locales/en-US/shiftMigration.json";
import catalogEnUSShiftNotes from "../../../../translations/locales/en-US/shiftNotes.json";
import catalogEnUSShiftPaymentRetry from "../../../../translations/locales/en-US/shiftPaymentRetry.json";
import catalogEnUSSmsPortal from "../../../../translations/locales/en-US/smsPortal.json";
import catalogEnUSSpendingControls from "../../../../translations/locales/en-US/spendingControls.json";
import catalogEnUSUpcomingCharges from "../../../../translations/locales/en-US/upcomingCharges.json";
import catalogEnUSWorkerDocuments from "../../../../translations/locales/en-US/workerDocuments.json";
import catalogEnUSWorkerFeedback from "../../../../translations/locales/en-US/workerFeedback.json";
import catalogEnUSWorkerProfile from "../../../../translations/locales/en-US/workerProfile.json";
import catalogEnUSWorkplaceAnalytics from "../../../../translations/locales/en-US/workplaceAnalytics.json";
import catalogEnUSWorkplaceChargeLeadTimeDifferentials from "../../../../translations/locales/en-US/workplaceChargeLeadTimeDifferentials.json";
import catalogEnUSWorkplaceRulesQuiz from "../../../../translations/locales/en-US/workplaceRulesQuiz.json";
import catalogEnUSWorkplaceUsers from "../../../../translations/locales/en-US/workplaceUsers.json";
import catalogEs419BillingHistory from "../../../../translations/locales/es-419/billingHistory.json";
import catalogEs419ChangeOfOwnership from "../../../../translations/locales/es-419/changeOfOwnership.json";
import catalogEs419Charting from "../../../../translations/locales/es-419/charting.json";
import catalogEs419Chat from "../../../../translations/locales/es-419/chat.json";
import catalogEs419Common from "../../../../translations/locales/es-419/common.json";
import catalogEs419Dnr from "../../../../translations/locales/es-419/dnr.json";
import catalogEs419Evidence from "../../../../translations/locales/es-419/evidence.json";
import catalogEs419FacilityUser from "../../../../translations/locales/es-419/facilityUser.json";
import catalogEs419GettingStarted from "../../../../translations/locales/es-419/gettingStarted.json";
import catalogEs419HelpCenter from "../../../../translations/locales/es-419/helpCenter.json";
import catalogEs419HomeHealth from "../../../../translations/locales/es-419/homeHealth.json";
import catalogEs419LiveWorkerEta from "../../../../translations/locales/es-419/liveWorkerEta.json";
import catalogEs419Login from "../../../../translations/locales/es-419/login.json";
import catalogEs419MissedPunchRequest from "../../../../translations/locales/es-419/missedPunchRequest.json";
import catalogEs419MyAccount from "../../../../translations/locales/es-419/myAccount.json";
import catalogEs419MyProfessionals from "../../../../translations/locales/es-419/myProfessionals.json";
import catalogEs419Navigation from "../../../../translations/locales/es-419/navigation.json";
import catalogEs419Orientation from "../../../../translations/locales/es-419/orientation.json";
import catalogEs419PrnRoster from "../../../../translations/locales/es-419/prnRoster.json";
import catalogEs419PushNotifications from "../../../../translations/locales/es-419/pushNotifications.json";
import catalogEs419RateRequest from "../../../../translations/locales/es-419/rateRequest.json";
import catalogEs419RatingPrompt from "../../../../translations/locales/es-419/ratingPrompt.json";
import catalogEs419ReferAndEarn from "../../../../translations/locales/es-419/referAndEarn.json";
import catalogEs419Reporting from "../../../../translations/locales/es-419/reporting.json";
import catalogEs419RequiredDocuments from "../../../../translations/locales/es-419/requiredDocuments.json";
import catalogEs419RequirementV2 from "../../../../translations/locales/es-419/requirementV2.json";
import catalogEs419Schedule from "../../../../translations/locales/es-419/schedule.json";
import catalogEs419Settings from "../../../../translations/locales/es-419/settings.json";
import catalogEs419Shift from "../../../../translations/locales/es-419/shift.json";
import catalogEs419ShiftMigration from "../../../../translations/locales/es-419/shiftMigration.json";
import catalogEs419ShiftNotes from "../../../../translations/locales/es-419/shiftNotes.json";
import catalogEs419ShiftPaymentRetry from "../../../../translations/locales/es-419/shiftPaymentRetry.json";
import catalogEs419SmsPortal from "../../../../translations/locales/es-419/smsPortal.json";
import catalogEs419SpendingControls from "../../../../translations/locales/es-419/spendingControls.json";
import catalogEs419UpcomingCharges from "../../../../translations/locales/es-419/upcomingCharges.json";
import catalogEs419WorkerDocuments from "../../../../translations/locales/es-419/workerDocuments.json";
import catalogEs419WorkerFeedback from "../../../../translations/locales/es-419/workerFeedback.json";
import catalogEs419WorkerProfile from "../../../../translations/locales/es-419/workerProfile.json";
import catalogEs419WorkplaceAnalytics from "../../../../translations/locales/es-419/workplaceAnalytics.json";
import catalogEs419WorkplaceChargeLeadTimeDifferentials from "../../../../translations/locales/es-419/workplaceChargeLeadTimeDifferentials.json";
import catalogEs419WorkplaceRulesQuiz from "../../../../translations/locales/es-419/workplaceRulesQuiz.json";
import catalogEs419WorkplaceUsers from "../../../../translations/locales/es-419/workplaceUsers.json";
import type { TranslationCatalogs } from "../types";

export const I18N_TRANSLATION_CATALOGS = {
  "en-US": {
    billingHistory: catalogEnUSBillingHistory,
    changeOfOwnership: catalogEnUSChangeOfOwnership,
    charting: catalogEnUSCharting,
    chat: catalogEnUSChat,
    common: catalogEnUSCommon,
    dnr: catalogEnUSDnr,
    evidence: catalogEnUSEvidence,
    facilityUser: catalogEnUSFacilityUser,
    gettingStarted: catalogEnUSGettingStarted,
    helpCenter: catalogEnUSHelpCenter,
    homeHealth: catalogEnUSHomeHealth,
    liveWorkerEta: catalogEnUSLiveWorkerEta,
    login: catalogEnUSLogin,
    missedPunchRequest: catalogEnUSMissedPunchRequest,
    myAccount: catalogEnUSMyAccount,
    myProfessionals: catalogEnUSMyProfessionals,
    navigation: catalogEnUSNavigation,
    orientation: catalogEnUSOrientation,
    prnRoster: catalogEnUSPrnRoster,
    pushNotifications: catalogEnUSPushNotifications,
    rateRequest: catalogEnUSRateRequest,
    ratingPrompt: catalogEnUSRatingPrompt,
    referAndEarn: catalogEnUSReferAndEarn,
    reporting: catalogEnUSReporting,
    requiredDocuments: catalogEnUSRequiredDocuments,
    requirementV2: catalogEnUSRequirementV2,
    schedule: catalogEnUSSchedule,
    settings: catalogEnUSSettings,
    shift: catalogEnUSShift,
    shiftMigration: catalogEnUSShiftMigration,
    shiftNotes: catalogEnUSShiftNotes,
    shiftPaymentRetry: catalogEnUSShiftPaymentRetry,
    smsPortal: catalogEnUSSmsPortal,
    spendingControls: catalogEnUSSpendingControls,
    upcomingCharges: catalogEnUSUpcomingCharges,
    workerDocuments: catalogEnUSWorkerDocuments,
    workerFeedback: catalogEnUSWorkerFeedback,
    workerProfile: catalogEnUSWorkerProfile,
    workplaceAnalytics: catalogEnUSWorkplaceAnalytics,
    workplaceChargeLeadTimeDifferentials: catalogEnUSWorkplaceChargeLeadTimeDifferentials,
    workplaceRulesQuiz: catalogEnUSWorkplaceRulesQuiz,
    workplaceUsers: catalogEnUSWorkplaceUsers,
  },
  "es-419": {
    billingHistory: catalogEs419BillingHistory,
    changeOfOwnership: catalogEs419ChangeOfOwnership,
    charting: catalogEs419Charting,
    chat: catalogEs419Chat,
    common: catalogEs419Common,
    dnr: catalogEs419Dnr,
    evidence: catalogEs419Evidence,
    facilityUser: catalogEs419FacilityUser,
    gettingStarted: catalogEs419GettingStarted,
    helpCenter: catalogEs419HelpCenter,
    homeHealth: catalogEs419HomeHealth,
    liveWorkerEta: catalogEs419LiveWorkerEta,
    login: catalogEs419Login,
    missedPunchRequest: catalogEs419MissedPunchRequest,
    myAccount: catalogEs419MyAccount,
    myProfessionals: catalogEs419MyProfessionals,
    navigation: catalogEs419Navigation,
    orientation: catalogEs419Orientation,
    prnRoster: catalogEs419PrnRoster,
    pushNotifications: catalogEs419PushNotifications,
    rateRequest: catalogEs419RateRequest,
    ratingPrompt: catalogEs419RatingPrompt,
    referAndEarn: catalogEs419ReferAndEarn,
    reporting: catalogEs419Reporting,
    requiredDocuments: catalogEs419RequiredDocuments,
    requirementV2: catalogEs419RequirementV2,
    schedule: catalogEs419Schedule,
    settings: catalogEs419Settings,
    shift: catalogEs419Shift,
    shiftMigration: catalogEs419ShiftMigration,
    shiftNotes: catalogEs419ShiftNotes,
    shiftPaymentRetry: catalogEs419ShiftPaymentRetry,
    smsPortal: catalogEs419SmsPortal,
    spendingControls: catalogEs419SpendingControls,
    upcomingCharges: catalogEs419UpcomingCharges,
    workerDocuments: catalogEs419WorkerDocuments,
    workerFeedback: catalogEs419WorkerFeedback,
    workerProfile: catalogEs419WorkerProfile,
    workplaceAnalytics: catalogEs419WorkplaceAnalytics,
    workplaceChargeLeadTimeDifferentials: catalogEs419WorkplaceChargeLeadTimeDifferentials,
    workplaceRulesQuiz: catalogEs419WorkplaceRulesQuiz,
    workplaceUsers: catalogEs419WorkplaceUsers,
  },
} as const satisfies TranslationCatalogs;
/* eslint-enable import/max-dependencies -- generated translation catalog imports every locale namespace */
